import { reactive } from 'vue'
import analytics from "@/analytics";
import axios from "axios";
import {EventBus} from "@/eventBus";

function isValidUserObject(_user) {
    return (
        _user &&
        (typeof _user._id === 'string') &&
        (typeof _user.username === 'string') &&
        Array.isArray(_user.viewed) &&
        Array.isArray(_user.watchlist) &&
        Array.isArray(_user.ceremonies_reviewed)
    );
}

export const userStore = reactive({
    user: null,
    cached_films_reviewed: [],
    update_films_reviewed_timer: null,

    setUser(_user) {
        // clearing the user?
        if ( !_user ) {
            if ( this.user ) {
                this.user = null;
                this.cached_films_reviewed = [];
                analytics.setUser(null);
                // gaSet({
                //     user_id: undefined,
                //     user_properties: undefined
                // });
            }
            return null;
        }

        // setting the user
        if ( !isValidUserObject(_user) ) {
            throw Error(`trying to set user that's not a valid user object: ${_user}`)
        }

        // new user?
        if ( _user._id != this.user?._id ) {
            this.cached_films_reviewed = [];
            analytics.setUser(_user);
        }

        this.user = _user;

        //console.log(`set user ${this.user._id} (${this.user.username})`)
        return this.user;
    },
    getUserId() {
        return this.user?._id;
    },

    // reviewing films and ceremonies
    markFilmReviewed(_film_id) {

        if ( !this.isLoggedIn() ||
            this.cached_films_reviewed.includes(_film_id) ||
            this.hasReviewedFilm(_film_id)
        ) {
            //console.log(`markFilmReviewed() NOT adding ${_film_id}`);
            return false;
        }

        //console.log(`markFilmReviewed() adding ${_film_id}`);
        this.cached_films_reviewed.push(_film_id);
        EventBus.emit('film-reviewed', _film_id);

        if ( !this.update_films_reviewed_timer ) {
            this.update_films_reviewed_timer = setTimeout(async () => {

                this.update_films_reviewed_timer = null;
                //console.log(`sending 'films-reviewed' with ${this.cached_films_reviewed}`);
                const data = {films: [...this.cached_films_reviewed]}
                this.cached_films_reviewed = [];
                return axios.post(`/api/user/films-reviewed`, data)
                    .then(response => {
                        //console.log(`'films-reviewed' replied with status ${response.status}`);
                        if ( response.status === 200 ) {
                            this.setUser(response.data);
                        }
                    })
                    .catch(err => {
                        analytics.notifyBugsnagOfError(err);
                    });
            }, 2000);
        }

        return true;
    },

    hasReviewedFilm(_film_id) {
        return this.user?.films_reviewed?.includes(_film_id);
    },
    isCeremonyReviewed(_ceremony) {
        return this.user?.ceremonies_reviewed?.includes(_ceremony);
    },

    // marking films viewed
    isFilmMarkedViewed(_film_id) {
        return this.user?.viewed?.includes(_film_id);
    },

    // marking films bookmarked
    isFilmBookmarked(_film_id) {
        return this.user?.watchlist?.includes(_film_id);
    },
    isFilmBookmarkedAndUnviewed(_film_id) {
        return this.isFilmBookmarked(_film_id) && !this.isFilmMarkedViewed(_film_id);
    },


    isLoggedIn() {
        return (this.user !== null);
    },
    isFullMember() {
        return !!this.membershipType();
    },
    membershipType() {
        return (this.isLoggedIn() && this.user.membershipType);
    },
    isAdmin() {
      return (this.isLoggedIn() && this.user.isAdmin);
    },
    isTester() {
        return (this.isLoggedIn() && this.user.isTester);
    },
    isDevAcquaintance() {
        return (this.isLoggedIn() && this.user.isDevAcquaintance);
    },
    isLegacyUser() {
        return (this.isLoggedIn() && this.user.isLegacyUser);
    },
    hasPermissionToSeeProfile(_userId) {

        // Admins can see anyone's profile
        if ( this.isAdmin() ) {
            return true;
        }

        // I have permission to see my own profile
        if ( _userId === this.user._id ) {
            return true;
        }

        // I have permission to see my friends' profiles
        if ( this.user.friends?.find(friend => (_userId === friend._id)) ) {
            return true;
        }

        // I have permission to see users who have invited me to be their friend
        if ( this.user.friends_waiting_for_approval?.find(friend => (_userId === friend._id)) ) {
            return true;
        }

        return false;
    },
    getFriendConnectionId() {
      return this.getUserId();
    },
    search: {
        text: '',
        type: ''
    }
});

